import VForm from '@/vuetify_custom/v-form'
import { VBtn, VSelect, VCard, VCardTitle, VCardText, VChip, VIcon } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import DatePicker from '@/vuetify_custom/v-date-picker_v1'
import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
import TextareasField from '@/vuetify_custom/v-form/components/Textareas_Field.js'
import PurchaseUnit from '@/views/business/components/PurchaseUnit.vue'
import VPopSelect from '@/vuetify_custom/v-pop-select.vue'
import { mapGetters } from 'vuex'
import ViewerItem from './ViewerItem'
import VPopCk from './v-pop-ck.vue'
import VPopDel from './v-pop-del'
import { common_mixins, stock_mixins } from './EditMixIns.jsx'
import { commonValidateRule, createStockParams, isIllegalityValue, createVirtualStockParams } from '../utils'
import { formattingNumber, getsafe } from '@/libs/util.js'
import { query_stock} from '../service'
import styles from './index.module.less'
const commonValidateRuleGo = commonValidateRule('必选')
const commonValidateRuleGoOne = commonValidateRule('必填')
export default {
    mixins:[common_mixins, stock_mixins],
    data() {
        return {
            outListParent:[],
            outListChild: []
        }
    },
    created() {
        this.init()
        this.warehouses_hash
    },
    computed: {
        ...mapGetters({
            warehouses_hash: 'async/warehouses_hash',
          }),
        is_virtual_stock() {
            return this.params.is_virtual_stock
        },
        table_fields() {
            const _this = this
            let pre_arr = []
            if (_this.params.bill_type === 'OutSourcing') {
                pre_arr = [{
                    text: '入库类型',
                    align: 'center',
                    value: 'stock_in_type',
                    width: 150,
                    render:(_, __) => {
                        //   v-model={__.stock_in_type}
                        return <VSelect
                            v-model={__.stock_in_type}
                            class={styles['btn-f']} 
                            label=""
                            required
                            rules={[commonValidateRuleGo]}
                            item-text="label"
                            item-value="value"
                            items={[
                                {
                                    label: '需要入库',
                                    value: 'need'
                                },
                                {
                                    label: '无需入库',
                                    value: 'none'
                                }
                            ]}
                        />
                    }
                }]
            }
            return [
                {
                    text: '存货编码',
                    align: 'center',
                    value: 'uid',
                    width: 120,
                    fixed: 'left',
                },
                {
                    text: '存货名称',
                    align: 'center',
                    width: 150,
                    render: (_, __) => {
                        return <VPopSelect
                            outList={_this.outListParent}
                            v-model={__.stock_id}
                            text = ''
                            placeholder=''
                            required
                            url={query_stock}
                            handleSearch={({items = []} = {}) => {
                                   return items
                            }}
                            rules={[commonValidateRuleGo]}
                            contentHeigh={400}
                            on={{
                                change(item) {
                                    __.stock_id = item.id
                                    __.uid = item.uid
                                    __.barcode = item.barcode
                                    __.unit_price = 0
                                    __.stock_price_id = null
                                    // __._item = item
                                    // __. = null
                                    _this.$set(__, '_item', item)
                                    _this.addOutList(item, 'outListParent')
                                    
                                }
                            }}
                            render = {
                                (h, item) => {
                                    return <div>
                                        <p class={styles['p-c']}>
                                            {item.uid}
                                        </p>
                                        <p class={styles['p-c']}>
                                            {item.name}
                                        </p>
                                    </div>
                                }
                            }
                            valueRender={(_, item) => {
                                if (!item) {
                                    return ''
                                }
                                return item.name
                            }}
                        />
                    }
                },
                {
                    text: '条码/ISBN',
                    align: 'center',
                    value: 'barcode',
                    width: 150,
                },
                ...pre_arr,
                {
                    text: '采购数量',
                    align: 'center',
                    value: 'qty',
                    width: 85,
                    render: (_, __, index) => {
                         return <div>
                                <NumberField
                                    v-model={__}
                                    field = {{
                                            key: 'qty',
                                            change:() => {
                                                _this.getTotal(index)
                                               if (_this.is_virtual_stock) {
                                                // 计算配件数量
                                                 _this.params.contract_stock_parts.forEach((n, i) => {
                                                    _this.setPartsDosageProxy(i)
                                                 });
                                                 // 计算存货单价
                                                 _this.setUnitPrice(_this.params.contract_stocks[0])
                                               }
                                             },
                                             rules:[commonValidateRuleGoOne, (val) => {
                                                 const arr = __.contract_stock_warehouses.filter(item => item.warehouse_id && Number(item.qty))
                                                 if (arr.length) {
                                                    const total = arr.reduce((c_total, item) => {
                                                        return math.eval(`${c_total}+${item.qty}`)
                                                    }, 0)
                                                    return Number(total.toNumber && total.toNumber()) === Number(val) || '仓库的数量之和需要等于采购数量'
                                                }
                                                return true
                                             }],    
                                    }}
                                /> 
                                {__.contract_stock_warehouses.filter(item => item.warehouse_id && Number(item.qty)).map(item => {
                                    return <div style="padding:5px 0"><VChip color="green" small outlined>{_this.warehouses_hash[item.warehouse_id] && _this.warehouses_hash[item.warehouse_id].name}（{item.qty}）</VChip></div>
                                })}
                               
                                <VPopCk 
                                    on={{
                                        close: () => {
                                            _this.validate()
                                        }
                                    }}
                                    v-model={__.contract_stock_warehouses}
                                />
                                               { __.stock_id && <ViewerItem
                                                contractStock={__}
                                               
                                                >
                                                    最佳采购量计算
                                                </ViewerItem>} 
                         </div> 
                    }
                },
                {
                    text: '采购单价',
                    align: 'center',
                    value: 'unit_price',
                    width: 120,
                    render: (_, target, index) => {
                        //  NumberField
                        if (_this.is_virtual_stock) {
                            return formattingNumber(_, 6)
                        }
                        const stock_prices = getsafe(target, '_item.stock_prices', [])
                        return <PurchaseUnit
                            v-model={target}
                            stockPrices={stock_prices}
                            on={{
                                change: () => {
                                    this.$nextTick(() => this.getTotal(index))
                                }
                            }}
                        />
                    }
                },
                {
                    text: '总价',
                    align: 'center',
                    type: 'money_field',
                    value: 'total_price',
                    width: 120,
                },
                {
                    text: '预计到货时间',
                    align: 'center',
                    value: '222',
                    width: 160,
                    render: (_, __) => {
                        return <DatePicker
                            rules={[commonValidateRuleGo]}
                            v-model={__.estimate_arrival_time}
                        />
                        
                    }
                },
                {
                    text: '备注',
                    align: 'center',
                    value: 'remarks',
                    width: 200, 
                    render: (_, __) => {
                        return <TextareasField
                            v-model={__}
                            field = {{
                                key: 'remarks',
                            }}
                        /> 
                    }
                },
                {
                    text: '操作',
                    align: 'center',
                     width: 120,
                     fixed: 'right',
                    render: (_, __, index) => {
                        if (_this.is_virtual_stock) {
                            return 
                        }
                        return <VPopDel
                        title="确定删除该条数据？"
                        on={{
                            submit:() => {
                                _this.params.contract_stocks.splice(index, 1)
                            }
                        }}
                    />
                    }
                }
            ]
        },
        fields() {
            return [
                {
                    key:'table',
                    cols: 12,
                },
            ]
        },
        accessories_fields() {
            const _this = this
            return [
                {
                    text: '配件编码',
                    align: 'center',
                    value: 'uid',
                    width: 120,
                },
                {
                    text: '配件&名称',
                    align: 'center',
                    width: 120,
                    render: (_, __) => {
                        return <VPopSelect
                            outList={_this.outListChild}
                            v-model={__.stock_id}
                            text = ''
                            placeholder=''
                            required
                            url={query_stock}
                            handleSearch={({items = []} = {}) => {
                                   return items
                            }}
                            rules={[commonValidateRuleGo]}
                            contentHeigh={400}
                            on={{
                                change(item) {
                                    __.stock_id = item.id
                                    __.uid = item.uid
                                    __.barcode = item.barcode
                                    __._item = item
                                    _this.addOutList(item, 'outListChild')
                                }
                            }}
                            render = {
                                (h, item) => {
                                    return <div>
                                        <p class={styles['p-c']}>
                                            {item.uid}
                                        </p>
                                        <p class={styles['p-c']}>
                                            {item.name}
                                        </p>
                                    </div>
                                }
                            }
                            valueRender={(_, item) => {
                                if (!item) {
                                    return ''
                                }
                                return item.name
                            }}
                        />
                    }
                },
                {
                    text: '采购数量',
                    align: 'center',
                    value: 'qty',
                    width: 85,
                    render: (_, __, index) => {
                         return <div>
                                <NumberField
                                    v-model={__}
                                    field = {{
                                            key: 'qty',
                                            change:() => {
                                                _this.getVirtualTotal(index)
                                                _this.setPartsDosageProxy(index)
                                             },
                                             rules:[commonValidateRuleGoOne],    
                                    }}
                                />
                         </div> 
                    }
                },
                {
                    text: '采购单价',
                    align: 'center',
                    width: 120,
                    render: (_, __, index) => {
                        return <NumberField
                            v-model={__}
                            field = {{
                                key: 'unit_price',
                                change:() => {
                                    _this.getVirtualTotal(index)
                                 },
                                 rules:[commonValidateRuleGo]
                            }}
                        /> 
                    }
                },
                {
                    text: '总价',
                    align: 'center',
                    value: 'total_price',
                    width: 120, 
                },
                {
                    text: '配件用量',
                    align: 'center',
                    value: 'unit_qty',
                    width: 120, 
                    render: (_, __) => {
                        return <NumberField
                            v-model={__}
                            field = {{
                                key: 'unit_qty',
                                rules:[commonValidateRuleGoOne],
                            }}
                        /> 
                    }
                },
                {
                    text: '备注',
                    align: 'center',
                    value: 'remarks',
                    width: 200, 
                    render: (_, __) => {
                        return <TextareasField
                            v-model={__}
                            field = {{
                                key: 'remarks',
                            }}
                        /> 
                    }
                },
                {
                    text: '操作',
                    align: 'center',
                     width: 120,
                     fixed: 'right',
                    render: (_, __, index) => {

                        return <div>
                            <VBtn
                                small
                                text
                                fab
                                color="primary"
                                on={{
                                    click:() => {
                                        _this.params.contract_stock_parts.push(createVirtualStockParams())
                                    }
                                }}
                            >
                            <VIcon dark>
                                mdi-plus-circle-outline
                            </VIcon>
                        </VBtn>
                        { _this.params.contract_stock_parts && _this.params.contract_stock_parts.length !== 1 && <VPopDel
                            title="确定删除该条数据？"
                            on={{
                                submit:() => {
                                    _this.params.contract_stock_parts.splice(index, 1)
                                    _this.$nextTick(_this.getParentTotal)
                                }
                            }}
                        />}
                        </div>
                    }
                }
            ]
        }
    },
    methods: {
        addOutList(item, key) {
            const hash = this[key].reduce((total, i) => {
                total[i.id] = true
                return total
            }, {})
            if (hash[item.id]) {
                return 
            }
            this[key].push(item)
        },
        vProxy(kk) {
            let res = true
            const arr = ['base', 'base_c']
            arr.forEach(key => {
                if (!this.is_virtual_stock && key === 'base_c') {
                    return 
                }
                const current = this.$refs[key] && this.$refs[key][kk] && this.$refs[key][kk]()
                if (res && !current) {
                    res = false
                }
                 
            })
            return res
        },
        validate() {
            return this.vProxy('validate')
         },
         resetValidation() {
            return this.vProxy('resetValidation')
         },
        setPartsDosageProxy(c_index) {
            this.setPartsDosage(this.params.contract_stocks[0], this.params.contract_stock_parts[c_index])
        },
        setPartsDosage(parent_target, child_target) {
            const { qty:p_qty } = parent_target
            const { qty } = child_target
            if (isIllegalityValue(p_qty) || isIllegalityValue(qty)) {
                child_target.unit_qty = null
                return
            }
            child_target.unit_qty = math.eval(`${qty}/${p_qty}`).toFixed(2)
        },
        getTotal(index) {
            if (this.is_virtual_stock || !this.params.contract_stocks[index]) {
                // this.$nextTick(() => {
                //     this.setUnitPrice(this.params.contract_stocks[index])
                // })
                return 
            }
          const {unit_price, qty} = this.params.contract_stocks[index] 
          this.params.contract_stocks[index].total_price = math.eval(`${unit_price}*${qty}`).toFixed(2)
        },
        getVirtualTotal(index) {
            // 技术每一条配件的总价
           const {unit_price, qty} = this.params.contract_stock_parts[index]
           if (isIllegalityValue(unit_price) || isIllegalityValue(qty)) {
                this.params.contract_stock_parts[index].total_price = null
                return
            }
            this.params.contract_stock_parts[index].total_price = math.eval(`${unit_price}*${qty}`).toFixed(2)
            this.$nextTick(this.getParentTotal)
        },
        init() {
            this.$nextTick(() => {
                this.params.contract_stocks.forEach(item => {
                    if (item.stock) {
                        this.addOutList(item.stock, 'outListParent')
                    } else if (item._item) {
                        this.addOutList(item._item, 'outListParent')
                    }
                })

                this.params && this.params.contract_stock_parts && this.params.contract_stock_parts.forEach(item => {
                    if (item.stock) {
                        this.addOutList(item.stock, 'outListChild')
                    } else if (item._item) {
                        this.addOutList(item._item, 'outListChild')
                    }
                })
            })
        }
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
                <VCardTitle>
                        存货
                        {!_this.is_virtual_stock && <VBtn class={styles['btn-f']} 
                            
                            outlined
                            color="primary"
                            small
                            on={{
                                click: () => {
                                    _this.params.contract_stocks.push(createStockParams())
                                }
                            }}
                            >
                            添加存货
                        </VBtn>}
                        <span class={styles['inline-b']}>
                            <VSelect
                                v-model={_this.params.bill_type}
                                class={styles['btn-f']} 
                                label="订单类型"
                                item-text="label"
                                item-value="value"
                                disabled={_this.is_virtual_stock}
                                items={[
                                    {
                                        label: '标准订单',
                                        value: 'Standard'
                                    },
                                    {
                                        label: '委外订单',
                                        value: 'OutSourcing'
                                    }
                                ]}
                            />
                        </span>
                    </VCardTitle>
                    <VCardText> 
                        <VForm
                            ref="base"
                            fields={_this.fields}
                            scopedSlots={{
                                table:() => {
                                    return <VTable
                                        
                                            headers={this.table_fields}
                                            desserts={this.params.contract_stocks}
                                        />
                            
                                }
                            }}
                        />
                        {_this.is_virtual_stock && <div>
                            <h3 style="margin-top:20px">配件信息</h3>
                            <VForm
                                ref="base_c"
                                fields={_this.fields}
                                scopedSlots={{
                                    table:() => {
                                        return <VTable
                                                headers={this.accessories_fields}
                                                desserts={this.params.contract_stock_parts}
                                            />
                                
                                    }
                                }}
                            />
                        </div>}
            </VCardText>
        </VCard>
    </div> 
     
    }
}